import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router';
import { registerService } from '@/services/authService';
import { enqueueSnackbar } from 'notistack';
import { ArrowBack } from '@mui/icons-material';
import { routes } from '@/constants/routes';
import theme from '@/constants/theme';
import axios from 'axios';
import Input from '@/components/input/Input';
import Button from '@/components/input/Button';

export default function RegisterScreen() {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const handleRegister = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (loading) return;
    setLoading(true);
    if (password !== confirmPassword) {
      enqueueSnackbar({
        variant: 'error',
        message: 'Las contraseñas deben de coincidir.',
      });
      setLoading(false);
      return;
    }
    try {
      await registerService({ email, password, firstName, lastName });
      navigate('/login', { replace: true });
      enqueueSnackbar({
        variant: 'success',
        message: 'Registro exitoso.',
      });
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const errorMessage =
          error.response?.data?.message?.[0] ?? 'No completaste todos los campos correctamente.';

        enqueueSnackbar({
          variant: 'error',
          message: errorMessage,
        });
      } else {
        console.error('Unexpected error in register:', error);

        enqueueSnackbar({
          variant: 'error',
          message: 'Ocurrió un error inesperado.',
        });
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.background}>
      <Link to={routes.welcome} style={styles.homeIcon}>
        <ArrowBack />
      </Link>
      <form style={styles.container} onSubmit={handleRegister}>
        <h1 style={styles.title}>Registrarme</h1>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          <Input
            type="text"
            label="Nombre"
            placeholder="Escribe tu nombre"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            required
          />
          <Input
            type="text"
            label="Apellido"
            placeholder="Escribe tu apellido"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            required
          />
          <Input
            type="email"
            label="Correo"
            placeholder="Escribe tu correo"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <Input
            type="password"
            label="Contraseña"
            placeholder="Escribe tu contraseña"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <Input
            type="password"
            label="Confirmar contraseña"
            placeholder="Escribe tu contraseña de nuevo"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
          />
        </div>

        <Button variant="main" sx={styles.button} disabled={loading} loading={loading}>
          {loading ? 'Registrando...' : 'Registrarme'}
        </Button>
      </form>
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  background: {
    minHeight: '100vh',
    width: '100vw',
    backgroundColor: theme.colors.background.primary,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 16,
    position: 'relative',
    boxSizing: 'border-box',
  },
  homeIcon: {
    position: 'absolute',
    top: 24,
    left: 24,
    background: 'transparent',
    border: 'none',
    cursor: 'pointer',
    color: theme.colors.text.default,
  },
  container: {
    width: '100%',
    maxWidth: 400,
    marginTop: 60,
  },
  title: {
    fontSize: 28,
    fontWeight: 'bold',
    marginBottom: 24,
    color: '#FAFAFA',
    textAlign: 'center',
  },
  input: {
    height: 48,
    border: '1px solid #FAFAFA',
    borderRadius: 8,
    padding: '0 12px',
    marginBottom: 16,
    color: '#0F1A3D',
    backgroundColor: '#fff',
    width: '100%',
    fontSize: 16,
    boxSizing: 'border-box',
  },
  button: {
    justifyContent: 'center',
    fontWeight: 'bold',
    marginTop: 26,
    width: '100%',
  },
  buttonText: {
    color: '#fff',
    fontWeight: 'bold',
    fontSize: 16,
    textAlign: 'center',
  },
};
